(function () {
  /*
   * Modulo do componenet avisos-list (avisosList)
   */
  angular
    .module('menu', [])
  ;
})();
